/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Laststatechangewasinitiatedbyadmin6Inputs */

const en__field_laststatechangewasinitiatedbyadmin6 = /** @type {(inputs: _Field_Laststatechangewasinitiatedbyadmin6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`last state change was inititated by admin`)
};

const de__field_laststatechangewasinitiatedbyadmin6 = /** @type {(inputs: _Field_Laststatechangewasinitiatedbyadmin6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letzte Statusänderung wurde durch einen Admin herbeigeführt`)
};

/**
* | output |
* | --- |
* | "last state change was inititated by admin" |
*
* @param {_Field_Laststatechangewasinitiatedbyadmin6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_laststatechangewasinitiatedbyadmin6 = /** @type {((inputs?: _Field_Laststatechangewasinitiatedbyadmin6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Laststatechangewasinitiatedbyadmin6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_laststatechangewasinitiatedbyadmin6(inputs)
	return de__field_laststatechangewasinitiatedbyadmin6(inputs)
});
export { _field_laststatechangewasinitiatedbyadmin6 as "_field_lastStateChangeWasInitiatedByAdmin" }